module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.eventsLoaded || _vm.accountTypeIsPro) ? _c('div', [_c('section', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 last-examination__wrapper"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('WELCOME_NAME', {
    name: _vm.user.firstName,
    id: _vm.user.id
  })))])])]), _vm._v(" "), _c('section', {
    staticClass: "row mb-5"
  }, [(_vm.lastExamination) ? _c('div', {
    staticClass: "col-xs-12 col-md-6 last-examination__wrapper"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('LAST_EXAMINATION')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "last-examination__section"
  }, [_c('div', {
    staticClass: "calendar__info__date__wrapper calendar__info__date__wrapper--gray"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("moment")(_vm.lastExamination.isoDate, 'ddd')) + "\n                    "), _c('p', {
    staticClass: "date__day-number"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lastExamination.isoDate, 'D')))]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__month"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lastExamination.isoDate, 'MMM YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "app-box"
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lastExaminationCanBeDisplayed ?
    _vm.$t('EXAMINATION_ALREADY_AVAILABLE') :
    _vm.lastExaminationNeedsToComplete ?
    _vm.$t('EXAMINATION_NEEDS_DATA') :
    _vm.$t('WAITING_FOR_RESULT')) + "\n                    ")]), _vm._v(" "), _c('button', {
    class: _vm.lastExaminationCanBeDisplayed ?
      'app-btn app-btn--big app-btn-primary btn-check-result' :
      'app-btn app-btn--big app-btn-default',
    on: {
      "click": function($event) {
        return _vm.displayExaminationDetails(_vm.lastExamination)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('CHECK_IT')) + "\n                    ")])])])]) : _c('div', {
    staticClass: "col-xs-12 col-md-6 last-examination__wrapper"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('LAST_EXAMINATION')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "last-examination__section"
  }, [_c('div', {
    staticClass: "app-box app-box--content"
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t('NO_DATA_AVAILABLE')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('FOR_USE')))]), _vm._v(" "), (_vm.showActivationCodeInput) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('form', [_c('div', {
    staticClass: "form-group col-xs-12 col-md-8"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.errors.has('activation_code')) ? _c('p', {
    staticClass: "validate-danger",
    staticStyle: {
      "position": "absolute",
      "top": "-30px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/images/icons/excl-red.svg")
    }
  }), _vm._v("\n                                " + _vm._s(_vm.$t('INVALID_CODE_INSERTED')) + "\n                            ")]) : (_vm.activationCodeErrorInfo) ? _c('p', {
    staticClass: "validate-danger",
    staticStyle: {
      "position": "absolute",
      "top": "-30px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/images/icons/excl-red.svg")
    }
  }), _vm._v("\n                                " + _vm._s(_vm.activationCodeErrorInfo) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activationCode),
      expression: "activationCode"
    }],
    staticClass: "text-input -white-input",
    class: {
      validate: _vm.activationCodeIsInValid
    },
    attrs: {
      "type": "text",
      "name": "activation_code",
      "placeholder": _vm.$t('CODE_PLACEHOLDER')
    },
    domProps: {
      "value": (_vm.activationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activationCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "log-reg-form__remind-password",
    staticStyle: {
      "text-decoration": "none",
      "margin-top": "5px",
      "color": "#CF004A",
      "width": "100%",
      "text-align": "right"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showActivationCodeInput = false
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('CANCEL')) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.activatePackage.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('ACTIVATE')) + "\n                        ")])])])]) : _c('div', [_c('div', {
    staticClass: "package-section"
  }, [_c('div', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('EXAMINATIONS')))]), _vm._v(" "), _c('strong', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.thousandsSeparator(_vm.availableStocks)))]), _vm._v(" "), (_vm.availableStocksTest != 0) ? _c('div', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('TEST_EXAMINATIONS')))]), _vm._v(" "), _c('strong', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.thousandsSeparator(_vm.availableStocksTest)))])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-default btn-buy-package",
    class: {
      'btn-hover-disable': !_vm.userShopUrl
    },
    attrs: {
      "disabled": !_vm.userShopUrl
    },
    on: {
      "click": _vm.buyAnotherPackage
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('BUY_PACKAGE')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('YOU_HAVE_ALREADY_ACTIVATION_CODE')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "log-reg-form__remind-password",
    staticStyle: {
      "text-decoration": "none",
      "color": "#CF004A"
    },
    on: {
      "click": function($event) {
        _vm.showActivationCodeInput = true
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('ACTIVATE_PACKAGE')) + "\n                    ")])])])])]), _vm._v(" "), (!_vm.accountTypeIsPro) ? _c('section', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title-content"
  }, [_vm._v(_vm._s(_vm.$t('NEXT_EXAMINATION_POSSIBLE')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-7"
  }, [_c('vue-calendar', {
    attrs: {
      "first-day": 1,
      "events": _vm.events
    },
    on: {
      "dayClicked": _vm.dayClicked,
      "eventClicked": _vm.eventClicked,
      "monthChanged": _vm.monthChanged
    }
  })], 1), _vm._v(" "), (_vm.brasterAllowed) ? _c('braster-allowed', {
    attrs: {
      "firstPeriodDay": _vm.firstPeriodDay,
      "firstAllowedDay": _vm.firstAllowedDay,
      "lastAllowedDay": _vm.lastAllowedDay
    },
    on: {
      "showVideo": _vm.showVimeo
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brasterAllowedState) ? _c('section', {
    staticClass: "col-xs-12 col-sm-5 hide"
  }, [_c('div', {
    staticClass: "calendar__info"
  }, [_c('div', {
    staticClass: "calendar__info__item"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('FIRST_PERIOD_DAY')))]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__date__wrapper"
  }, [_c('div', {
    staticClass: "calendar__info__date"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'dd')))]), _vm._v(" "), _c('span', {
    staticClass: "date__day-number"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'DD')))])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__month"
  }, [_c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'MMM')) + "\n                                        " + _vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'YYYY')) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__tooltip"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('FIRST_PERIOD_DAY_INFO')) + "\n                                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isDisallowed) ? _c('braster-disallowed') : _vm._e(), _vm._v(" "), (_vm.firstPeriodDaySection) ? _c('section', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "calendar__info"
  }, [_c('div', {
    staticClass: "calendar__info__item"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('FIRST_PERIOD_DAY')))]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__date__wrapper"
  }, [_c('div', {
    staticClass: "calendar__info__date"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'dd')))]), _vm._v(" "), _c('span', {
    staticClass: "date__day-number"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'DD')))])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__month"
  }, [_c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'MMM')) + "\n                                        " + _vm._s(_vm._f("moment")(_vm.firstPeriodDay, 'YYYY')) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio__wrapper"
  }, [_c('v-radio-group', {
    staticClass: "input-date-wrapper",
    on: {
      "change": _vm.updateIsFirstPeriodDay
    },
    model: {
      value: (_vm.isFirstPeriodDay),
      callback: function($$v) {
        _vm.isFirstPeriodDay = $$v
      },
      expression: "isFirstPeriodDay"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('YES'),
      "color": "red darken-3",
      "value": true
    }
  })], 1), _vm._v(" "), _c('v-radio-group', {
    staticClass: "input-date-wrapper",
    on: {
      "change": _vm.updateIsFirstPeriodDay
    },
    model: {
      value: (_vm.isFirstPeriodDay),
      callback: function($$v) {
        _vm.isFirstPeriodDay = $$v
      },
      expression: "isFirstPeriodDay"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('NO'),
      "color": "red darken-3",
      "value": false
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.cycleLengthSection) ? _c('div', {
    staticClass: "calendar__info__item"
  }, [_c('div', {
    staticClass: "next-examination__wrapper"
  }, [_c('h4', {
    staticClass: "calendar__info__title --no-border mb-1"
  }, [_vm._v(_vm._s(_vm.$t('CYCLE_LENGTH')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('SELECT'),
      "disabled": ""
    },
    model: {
      value: (_vm.cycleLength),
      callback: function($$v) {
        _vm.cycleLength = $$v
      },
      expression: "cycleLength"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.cycleLength,
      "value": _vm.cycleLength
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary --wild mt-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.confirmFirstPeriodDay.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('APPLY')) + "\n                                        ")])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.lastPeriodSection) ? _c('div', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "calendar__info"
  }, [(_vm.lastPeriodDaySection) ? _c('div', {
    staticClass: "calendar__info__item"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('LAST_PERIOD')))]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__date__wrapper"
  }, [_c('div', {
    staticClass: "calendar__info__date"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'dd')))]), _vm._v(" "), _c('span', {
    staticClass: "date__day-number"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'DD')))])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__month"
  }, [_c('span', [_vm._v("\n                                        " + _vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'MMM')) + "\n                                        " + _vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'YYYY')) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__tooltip"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('FIRST_PERIOD_DAY_INFO')) + "\n                                ")])]) : _vm._e(), _vm._v(" "), (_vm.lastExaminationSection && _vm.lastExamination) ? _c('div', {
    staticClass: "calendar__info__item"
  }, [_c('div', {
    staticClass: "next-examination__wrapper"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('LAST_BRASTER_EXAMINATION')) + ":")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "next-examination__date"
  }, [_vm._v(_vm._s(_vm.dateFormat(_vm.lastExamination.isoDate)))])])]) : _vm._e(), _vm._v(" "), (_vm.nextExaminationSection) ? _c('div', {
    staticClass: "calendar__info__item"
  }, [_c('div', {
    staticClass: "next-examination__wrapper"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('NEXT_BRASTER_EXAMINATION')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "next-examination__legend"
  }), _vm._v(" "), (_vm.firstAllowedDay && _vm.lastAllowedDay) ? _c('div', {
    staticClass: "next-examination__date"
  }, [(_vm.todayIsLastAllowedForecast) ? [_vm._v("\n                                        " + _vm._s(_vm.dateFormat(_vm.firstAllowedDayIfTodayIsLastPeriodForecast)) + "-" + _vm._s(_vm.dateFormat(_vm.lastAllowedDayIfTodayIsLastPeriodForecast)) + "\n                                    ")] : [_vm._v(_vm._s(_vm.dateFormat(_vm.firstAllowedDay)) + "-" + _vm._s(_vm.dateFormat(_vm.lastAllowedDay)))], _vm._v(" "), _c('a', {
    staticClass: "trigger",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.showVimeo()
      }
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('HOW_TO_MAKE_EXAMINATION')) + "\n                                        "), _c('img', {
    staticClass: "link-img",
    attrs: {
      "src": "/src/assets/images/arrow-red.png"
    }
  })])], 2) : _c('div', {
    staticClass: "next-examination__date"
  }, [_c('span', {
    staticClass: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('SELECT_DATE_FROM_CALENDAR')))])])])]) : _vm._e()])]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    on: {
      "close": _vm.closeModal
    }
  }, [_c('app-buy-package', {
    on: {
      "buy": _vm.buyAnotherPackage,
      "close": _vm.closeModal
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.accountTypeIsPro && _vm.checkMyDataModal) ? _c('app-modal', {
    on: {
      "close": _vm.updateLastQuestionedDay
    }
  }, [_c('check-your-data', {
    on: {
      "gotomydata": _vm.goToMyData,
      "close": _vm.updateLastQuestionedDay
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showVimeoModal) ? _c('app-modal', {
    on: {
      "close": _vm.closeModal
    }
  }, [_c('what-is-braster')], 1) : _vm._e(), _vm._v(" "), (!_vm.checkAgreementStatus) ? _c('terms-agreement', {
    on: {
      "agree": _vm.closeTermsModal
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-examination__legend next-examination__legend--transparent"
  }, [_c('img', {
    staticClass: "legend-img",
    attrs: {
      "src": require("../../../assets/images/braster-logo-app.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6042c684","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/my-account/my-account.vue
// module id = 1209
// module chunks = 0